import React from "react";

export function HiddenErrorTemplate() {
  return <div />;
}
